export default "__VITE_ASSET__P0EuqvZW__"